import { useState } from "react";
import { faqs } from "@/mocks/media";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (i: number) => setOpenIndex((cur) => (cur === i ? -1 : i));

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,360px)_1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-primary-500" />
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-primary-500">
                Q &amp; A
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              关于黑料与公关的
              <br />
              常见问答
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              把你最常问的问题集中作答，帮助建立一套看待这类议题的基本框架。若仍有疑问，欢迎通过下方表单投递给我们。
            </p>
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              去提问 / 投递选题
              <i className="ri-arrow-down-line text-base" />
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((item, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    open ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}